// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1288k","Label":"BuildControl_Label__2526H","Less":"BuildControl_Less__2yrt6","More":"BuildControl_More__2s6d0"};